import { PromotionContainer } from '@/components/blocks/FreeGiftPromotionCard/parts/PromotionContainer';
import { filterValidCombinablePromotions } from '@/components/blocks/FreeGiftV2/utils';
import { PaperCard } from '@/components/content/ProductDetails/parts/PaperCards';
import { PROMOTION_TYPES } from '@/data/constants/promoIconConstants';
import { useDefaultStore } from '@/data/Content/DefaultStore';
import { findPromoIconsFromAttributeByStoreAndMarketId } from '@/data/Content/PromoIcons';
import { usePromoMessage } from '@/data/Content/PromoMessage';
import { isB2BStore, useSettings } from '@/data/Settings';
import { ResponseProductAttribute } from '@/data/types/Product';
import { getStoreDataByPhysicalStoreId } from '@/data/utils/commonIntegrationUtils';
import { validateStoreExclude } from '@/data/utils/validateStoreExclude';
import { FC } from 'react';

type FreeGiftPromotionCardType = {
	id: string;
	attributes?: ResponseProductAttribute[];
	partNumber?: string;
};

export const FreeGiftPromotionCard: FC<FreeGiftPromotionCardType> = ({
	id: catentryId,
	attributes,
	partNumber = '',
}) => {
	const { settings } = useSettings();
	const isB2B = isB2BStore(settings);
	const { physicalStoreId } = useDefaultStore();
	const { marketId } = getStoreDataByPhysicalStoreId(physicalStoreId);

	const promoIconsAttrs = findPromoIconsFromAttributeByStoreAndMarketId(
		attributes || [],
		isB2B,
		marketId || ''
	);

	const freeGiftPromoAttr = promoIconsAttrs.find((attr) => {
		if (attr.identifier === PROMOTION_TYPES.PROMOICON_FP) return true;
		if (attr.identifier === PROMOTION_TYPES.PROMOICON_FP_REWARD) {
			return validateStoreExclude(attr, physicalStoreId || '');
		}
		return false;
	});

	const { data: promoMessage } = usePromoMessage(catentryId);

	const hasValidPromotions =
		filterValidCombinablePromotions(promoMessage?.combinablePromotions ?? []).length > 0;

	if (!freeGiftPromoAttr || !promoMessage || !hasValidPromotions) return null;

	const isReward = freeGiftPromoAttr.identifier === PROMOTION_TYPES.PROMOICON_FP_REWARD;

	return (
		<PaperCard sx={{ padding: { xs: '10px', md: '20px' } }} id="freeGiftCard">
			<PromotionContainer promoData={promoMessage} partNumber={partNumber} isReward={isReward} />
		</PaperCard>
	);
};
